import React, { FC } from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@material-ui/styles";
import theme from "./theme";
import Routes from "./Route";
import CssBaseline from "@material-ui/core/CssBaseline";
import { IntlProvider } from "react-intl";
import { getLocale } from "./services/Locale";
import messages from "./locales/messages";
import { ToastProvider } from "./components/Ui/Toast";

const locale = getLocale();
const App: FC = () => {
  return (
    <ToastProvider>
      <IntlProvider locale={locale} messages={(messages as any)[locale]}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </ThemeProvider>
      </IntlProvider>
    </ToastProvider>
  );
};

export default App;
